import { TotalSpendFilterForm } from "./forms/filters/TotalSpendFilterForm";
import { OrderCountFilterForm } from "./forms/filters/OrderCountFilterForm";
import { AverageTicketFilterForm } from "./forms/filters/AverageTicketFilterForm";
import { LastConversionFilterForm } from "./forms/filters/LastConversionFilterForm";
import { AgeFilterForm } from "./forms/filters/AgeFilterForm";
import { BirthdayFilterForm } from "./forms/filters/BirthdayFilterForm";
import { RegisterTimeFilterForm } from "./forms/filters/RegisterTimeFilterForm";
import { RegionFilterForm } from "./forms/filters/RegionFilterForm";
import { TriggerForm } from "./forms/trigger/TriggerForm";
import { ImportedAudienceForm } from "./forms/audience/ImportedAudienceForm";
import { BroadcastAudienceForm } from "./forms/audience/BroadcastAudienceForm";
import { PushCreativeActionForm } from "./forms/actions/PushCreativeActionForm";
import { EmailCreativeActionForm } from "./forms/actions/EmailCreativeActionForm";
import { WhatsAppCreativeActionForm } from "./forms/actions/WhatsAppCreativeActionForm";
import { SmsCreativeActionForm } from "./forms/actions/SmsCreativeActionForm";
import { ClimateProfileFilterForm } from "./forms/filters/ClimateProfileFilterForm";
import { DayOfWeekConditionalForm } from "./forms/conditionals/DayOfWeekConditionalForm";
import { DayOfMonthConditionalForm } from "./forms/conditionals/DayOfMonthConditionalForm";
import { SpecificDayConditionalForm } from "./forms/conditionals/SpecificDayConditionalForm";
import { RegisterTimeConditionalForm } from "./forms/conditionals/RegisterTimeConditionalForm";
import { RegionConditionalForm } from "./forms/conditionals/RegionConditionalForm";
import { BirthdayConditionalForm } from "./forms/conditionals/BirthdayConditionalForm";
import { ClimateProfileConditionalForm } from "./forms/conditionals/ClimateProfileConditionalForm";
import { OrderCountConditionalForm } from "./forms/conditionals/OrderCountConditionalForm";
import { AverageTicketConditionalForm } from "./forms/conditionals/AverageTicketConditionalForm";
import { LastConversionConditionalForm } from "./forms/conditionals/LastConversionConditionalForm";
import { AgeConditionalForm } from "./forms/conditionals/AgeConditionalForm";
import { TotalSpendConditionalForm } from "./forms/conditionals/TotalSpendConditionalForm";
import { SpecificClimateConditionalForm } from "./forms/conditionals/SpecificClimateConditionalForm";
import { ConsumedProductsFilterForm } from "./forms/filters/ConsumedProductsFilterForm";
import { ConsumedProductsConditionalForm } from "./forms/conditionals/ConsumedProductsConditionalForm";

import { FilterGroupForm } from "./forms/groups/FilterGroupForm";
import { ConditionalGroupForm } from "./forms/groups/ConditionalGroupForm";
import { CreativeGroupActionForm } from "./forms/groups/CreativeGroupActionForm";
import { ConsumptionMomentsFilterForm } from "./forms/filters/ConsumptionMomentsFilterForm";
import { ConsumptionMomentsConditionalForm } from "./forms/conditionals/ConsumptionMomentsConditionalForm";
import { OriginFilterForm } from "./forms/filters/OriginFilterForm";
import { OriginConditionalForm } from "./forms/conditionals/OriginConditionalForm";
import { BrandsAndUnitsFilterForm } from "./forms/filters/BrandsAndUnitsFilterForm";
import { BrandsAndUnitsConditionalForm } from "./forms/conditionals/BrandsAndUnitsConditionalForm";
import { AudienceGroupForm } from "./forms/groups/AudienceGroupForm";
import { EventSourceForm } from "./forms/sources/EventSourceForm";
import { DaysWithoutConversionFilterForm } from "./forms/filters/DaysWithoutConversionFilterForm";
import { DaysWithoutConversionConditionalForm } from "./forms/conditionals/DaysWithoutConversionConditionalForm";
import { OrderFrequencyConditionalForm } from "./forms/conditionals/OrderFrequencyConditionalForm";
import { OrderFrequencyFilterForm } from "./forms/filters/OrderFrequencyFilterForm";
import { RFVProfileFilterForm } from "./forms/filters/RFVProfileFilterForm";
import { RFVProfileConditionalForm } from "./forms/conditionals/RFVProfileConditionalForm";
import { OrderFilterForm } from "./forms/filters/OrderFilterForm";
import { OrderConditionalForm } from "./forms/conditionals/OrderConditionalForm";
import { CustomerPhoneFilterForm } from "./forms/filters/CustomerPhoneFilterForm";
import { SavedAudienceForm } from "./forms/audience/SavedAudienceForm";
import { PushCreativeActionFormOld } from "./forms/actions/PushCreativeActionFormOld";
import { EmailCreativeActionFormOld } from "./forms/actions/EmailCreativeActionFormOld";
import { WhatsAppCreativeActionFormOld } from "./forms/actions/WhatsAppCreativeActionFormOld";
import { SmsCreativeActionFormOld } from "./forms/actions/SmsCreativeActionFormOld";
import { Environment } from "shared/core/Environment";

const isTheFamous = false;

export const BoxForms = {
  // Gatilhos
  Trigger: TriggerForm,
  // Públicos
  SavedAudience: SavedAudienceForm,
  ImportedAudience: ImportedAudienceForm,
  EventSource: EventSourceForm,
  BroadcastAudience: BroadcastAudienceForm,
  // Filtros
  RegisterTimeFilter: RegisterTimeFilterForm,
  RegionFilter: RegionFilterForm,
  TotalSpendFilter: TotalSpendFilterForm,
  ConsumedProductsFilter: ConsumedProductsFilterForm,
  BirthdayFilter: BirthdayFilterForm,
  ClimateProfileFilter: ClimateProfileFilterForm,
  ConsumptionMomentsFilter: ConsumptionMomentsFilterForm,
  OrderCountFilter: OrderCountFilterForm,
  AverageTicketFilter: AverageTicketFilterForm,
  LastConversionFilter: LastConversionFilterForm,
  AgeFilter: AgeFilterForm,
  OriginFilter: OriginFilterForm,
  BrandsAndUnitsFilter: BrandsAndUnitsFilterForm,
  DaysWithoutConversionFilter: DaysWithoutConversionFilterForm,
  OrderFilter: OrderFilterForm,
  // Condicionais
  DayOfWeekConditional: DayOfWeekConditionalForm,
  DayOfMonthConditional: DayOfMonthConditionalForm,
  SpecificDayConditional: SpecificDayConditionalForm,
  RegisterTimeConditional: RegisterTimeConditionalForm,
  RegionConditional: RegionConditionalForm,
  ConsumedProductsConditional: ConsumedProductsConditionalForm,
  TotalSpendConditional: TotalSpendConditionalForm,
  BirthdayConditional: BirthdayConditionalForm,
  SpecificClimateConditional: SpecificClimateConditionalForm,
  ClimateProfileConditional: ClimateProfileConditionalForm,
  ConsumptionMomentsConditional: ConsumptionMomentsConditionalForm,
  OrderCountConditional: OrderCountConditionalForm,
  AverageTicketConditional: AverageTicketConditionalForm,
  LastConversionConditional: LastConversionConditionalForm,
  AgeConditional: AgeConditionalForm,
  OriginConditional: OriginConditionalForm,
  BrandsAndUnitsConditional: BrandsAndUnitsConditionalForm,
  DaysWithoutConversionConditional: DaysWithoutConversionConditionalForm,
  OrderConditional: OrderConditionalForm,
  // Ações
  PushCreativeAction: !isTheFamous
    ? PushCreativeActionFormOld
    : PushCreativeActionForm,
  EmailCreativeAction: !isTheFamous
    ? EmailCreativeActionFormOld
    : EmailCreativeActionForm,
  WhatsAppCreativeAction: !isTheFamous
    ? WhatsAppCreativeActionFormOld
    : WhatsAppCreativeActionForm,
  SmsCreativeAction: !isTheFamous
    ? SmsCreativeActionFormOld
    : SmsCreativeActionForm,
  // Grupos
  FilterGroup: FilterGroupForm,
  ConditionalGroup: ConditionalGroupForm,
  CreativeGroupAction: CreativeGroupActionForm,
  AudienceGroup: AudienceGroupForm,

  OrderFrequencyConditionalForm,
  OrderFrequencyFilterForm,
  RFVProfileFilter: RFVProfileFilterForm,
  RFVProfileConditional: RFVProfileConditionalForm,
  CustomerPhoneFilter: CustomerPhoneFilterForm,
};
